var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPravachanHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pravachan",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.314,
    height: 58.88,
    viewBox: "0 0 66.314 58.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4513"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M529.232-433.321a29.752,29.752,0,0,1-4.032-13.294c-.437-7.765-4.945-13.455-11.988-16.739-7.084-3.3-14.076-2.754-20.69,1.546-10.21,6.35-13.423,21.736-4.1,32.274a4.935,4.935,0,0,1,1.337,3.639c-.062,5.54-.014,11.079-.043,16.619-.011,2.076.88,2.886,2.982,2.621q10.14-1.281,20.3-2.4c1.419-.156,1.937-.729,1.948-2.125.013-1.67-.767-3.885.333-4.876,1.238-1.114,3.328.146,5.054.289,3.07.256,5.048-1.443,5.149-4.59.065-2-.049-4.009-.082-6.013,0-.776,0-1.68,1.36-1.858C530.743-428.749,531.23-429.759,529.232-433.321Z",
    transform: "translate(-482.895 465.485)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M543.922-427.789a18.758,18.758,0,0,0-.791-4.651,30.513,30.513,0,0,0-2.825-5.7,1.6,1.6,0,0,1,.692-2.287c1.382-.964,1.879.031,2.418.915a22.348,22.348,0,0,1,3.061,15.813c-.3,1.565-2.768,11.42-5.422,9.291a1.432,1.432,0,0,1-.276-2.261,18.469,18.469,0,0,0,3.143-9.584Q543.953-427.017,543.922-427.789Z",
    transform: "translate(-480.535 466.503)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M540.935-428.465a17.006,17.006,0,0,1-.513,4.887c-.3,1.19-1.9,6.8-3.924,5.265-.806-.61-1.156-1.232-.565-2.238a12.218,12.218,0,0,0-.35-13.833c-.76-1.153-.069-1.732.738-2.374,1.042-.829,1.571-.153,2.113.628A14.481,14.481,0,0,1,540.935-428.465Z",
    transform: "translate(-480.734 466.655)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M534.984-427.858a9.637,9.637,0,0,1-.814,3.887c-.393.893-1.186,2.427-2.356,1.585-.741-.535-1.348-1.018-.76-2.139a5.754,5.754,0,0,0-.255-6.129c-.877-1.355.212-1.842,1.027-2.436a1,1,0,0,1,1.545.171A8.541,8.541,0,0,1,534.984-427.858Z",
    transform: "translate(-480.931 466.811)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPravachanHome);
export default __webpack_public_path__ + "static/media/pravachanHome.72c6d94b3704c04ac9a6872f2513b8b2.svg";
export { ForwardRef as ReactComponent };